import type { FC, PropsWithChildren } from 'react';

import type { BadgeProps } from '@mui/material';
import Badge from '@mui/material/Badge';

const AtpBadge: FC<PropsWithChildren<BadgeProps>> = ({ children, ...rest }) => {
  return <Badge {...rest}>{children}</Badge>;
};

export default AtpBadge;
